import { Component, OnInit, Input } from '@angular/core';

import { UiService } from '../../../services/core.ui.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { UserRest } from '../../../services/core.user.rest.service';

@Component({
  selector: 'lost-password-view',
  template: require('./lostpassword.component.html')
})
export class LostPasswordViewComponent implements OnInit {
  @Input() registrationMode: any;

  unixName = '';
  unixNameEmpty = false;

  constructor(
    private uiService: UiService,
    private translateService: GfTranslateService,
    private userRest: UserRest
  ) {}

  ngOnInit(): void {
    this.uiService.setFocus('lostUser');
  }

  submitLostPassword(): boolean {
    if (!this.validateForm()) {
      return false;
    }

    this.userRest.postReset(this.unixName)
      .then((response: any) => {
        console.log(response);
        this.uiService.message.showSuccess(
          this.translateService.translate('An email with reset instructions has been sent')
        );
      })
      .catch((response: any) => {
        console.log(response);
        this.uiService.message.showWarning(
          this.translateService.translate('Sorry, that username/email is not recognized by GForge')
        );
      });

    return true;
  }

  private validateForm(): boolean {
    this.unixNameEmpty = !this.unixName.trim();
    return !this.unixNameEmpty;
  }
}

